import { IHisItemSet } from "./IHisItemSet";

export interface IHisItemSelectable {
  selectedHisItemSets: IHisItemSet[];
}
  
export function instanceOfIHisItemSelectable(instance: any): instance is IHisItemSelectable {
  return (instance != null)
    && (instance.selectedHisItemSets !== undefined);
}
